import { StorageMap } from '@ngx-pwa/local-storage';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { environment } from 'src/environments/environment';
import { UtilService } from 'src/app/modules/shared/services/util.service';
import { LoyaltyService } from 'src/app/modules/retailer/services/loyalty.service';

@Component({
  selector: 'app-settings',
  templateUrl: './loyalty-settings.component.html',
  styleUrls: ['./loyalty-settings.component.scss']
})
export class LoyaltySettingsComponent implements OnInit {

  public loginData: any;

  public settingsForm: FormGroup;
  public settingsMode: string;
  public settingsLoader: any = false;
  public buttonLoader: any = false;

  constructor(
    private _router: Router,
    private _utilService: UtilService,
    private _loyaltyService: LoyaltyService
  ) {}

  ngOnInit(): void {
    // Set settings form
    this.settingsForm = new FormGroup({
      point_cash_value: new FormControl(0, [Validators.required, Validators.pattern("^[0-9]{1,3}(?:\.[0-9]{1,3})?$")]),
    });

    this.buttonLoader = false;
    this.settingsMode = 'add'; // Default

    this.getStorageData();
  }

  // Back to loyalty report
  onBackClick(){
    this._router.navigate(['/retailer/loyalty'], {});
  }

  async getStorageData() {
    this.loginData = await this._utilService.getStorageData('R_LOGIN');

    this.getLoyaltySettings();
  }

  async getLoyaltySettings() {
    this.settingsLoader = true;

    this._loyaltyService.getLoyaltySettings(this.loginData.token, this.loginData.user_details.provider_id).subscribe(async getLoyaltySettingsResponse => {
      this.settingsLoader = false;

      if (getLoyaltySettingsResponse.status === true) { // Success
        this.settingsMode = 'edit'; 

        // Set default settings values
        this.settingsForm.get('point_cash_value').setValue(getLoyaltySettingsResponse.point_cash_value);
      } else {
        this._utilService.showToast(getLoyaltySettingsResponse.message, '', 'error', {});
      }
    }, error => { // Error from getLoyaltySettings
      this.settingsLoader = false;
      this._utilService.showToast('Error while getting loyalty settings', '', 'error', {});
    });
  }

  // Save settings
  async onSaveSettings() {
    if (!this.settingsForm.value.point_cash_value) {
      this._utilService.showToast('Please enter point cash value', '', 'warning', {});
    } else if (this.settingsForm.controls.point_cash_value.status == 'INVALID') {
      this._utilService.showToast('Point cash value entered is invalid', '', 'warning', {});
    } else {
      let manageLoyaltySettingsBody = {
        retailer_id: this.loginData.user_details.provider_id,
        mode: this.settingsMode,
        point_cash_value: String(this.settingsForm.value.point_cash_value)
      };

      this.buttonLoader = true;

      // Check username & password
      this._loyaltyService.manageLoyaltySettings(this.loginData.token, manageLoyaltySettingsBody).subscribe(async manageLoyaltySettingsResponse => {
        this.buttonLoader = false;

        if (manageLoyaltySettingsResponse.status === true) { // Success
          this._utilService.showToast('Loyalty settings updated successfully', '', 'success', {});
        } else {
          this._utilService.showToast(manageLoyaltySettingsResponse.message, '', 'error', {});
        }
      }, error => { // Error from changeUserPassword
        this.buttonLoader = false;
      });
    }
  }

}
